//regular
import { faAddressCard } from '@fortawesome/pro-regular-svg-icons/faAddressCard';
import { faHeart } from '@fortawesome/pro-regular-svg-icons/faHeart';
import { faEye } from '@fortawesome/pro-regular-svg-icons/faEye';
import { faCheckCircle } from '@fortawesome/pro-regular-svg-icons/faCheckCircle';
import { faShoppingBasket } from '@fortawesome/pro-regular-svg-icons/faShoppingBasket';
import { faTags } from '@fortawesome/pro-regular-svg-icons/faTags';
import { faTruck } from '@fortawesome/pro-regular-svg-icons/faTruck';
import { faBox } from '@fortawesome/pro-regular-svg-icons/faBox';
import { faShieldCheck } from '@fortawesome/pro-regular-svg-icons/faShieldCheck';
import { faDollarSign } from '@fortawesome/pro-regular-svg-icons/faDollarSign';
import { faSyncAlt } from '@fortawesome/pro-regular-svg-icons/faSyncAlt';
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons/faAngleDown';
import { faAngleUp } from '@fortawesome/pro-regular-svg-icons/faAngleUp';
import { faPlusCircle } from '@fortawesome/pro-regular-svg-icons/faPlusCircle';
import { faMinusCircle } from '@fortawesome/pro-regular-svg-icons/faMinusCircle';
import { faMoneyCheckEditAlt } from '@fortawesome/pro-regular-svg-icons/faMoneyCheckEditAlt';
//solid
import { faSpinner } from '@fortawesome/pro-solid-svg-icons/faSpinner';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { faRibbon } from '@fortawesome/pro-solid-svg-icons/faRibbon';

//export array
export const icons = [
  faAddressCard,
  faShoppingBasket,
  faTags,
  faTruck,
  faBox,
  faShieldCheck,
  faSpinner,
  faHeart,
  faEye,
  faDollarSign,
  faCheckCircle,
  faSyncAlt,
  faInfoCircle,
  faAngleDown,
  faAngleUp,
  faPlusCircle,
  faMinusCircle,
  faMoneyCheckEditAlt,
  faRibbon,
];
